<script>
  /**
   * @overview 添加素材二级目录
   *
   * @author retro
   */
  import mapUtils, { $http, $token, $form, $list } from "@/utils";
  import * as materailManageServer from '../../api/materialManage';

  export default {
    name: "AddTwoMenu",

    props: {
      visible: {
        type: Boolean,
        default: false,
      },

      data: {
        type: Object,
        default: null,
      },
      parentId: {
        type: [String, Number],
      },
    },

    data: () => ({
      loading: false,
      formData: {
        scene: '',
      },
      rules: {
        scene: [{ required: true, message: '请输入' }],
      },
    }),
    methods: {
      submit() {
        this.$refs.form.validate((res) => {
          if (res) {
            this.addScene();
          }
        });
      },
      async addScene() {
        const self = this;
        const res = await materailManageServer.addResourceType({ name: self.formData.scene, parent_type_id: this.parentId });
        if (res && res.data && res.data.message) {
          this.$message.error(`${res.data.message}`);
        } else {
          this.$emit('success', this.formData.name);
          this.cancel();
        }
      },
      cancel() {
        this.$emit("update:visible", false);
        setTimeout(() => {
          this.formData.scene = '';
        }, 200);
        setTimeout(() => {
          this.$refs.form.clearValidate();
        }, 500);
      },
    },
  };
</script>

<template>
  <el-dialog
    :show-close="false"
    :visible="visible"
    width="550px"
    class="course-list-editor"
  >
    <div slot="title">
      新建目录
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
    >
      <el-form-item
        label="名称"
        prop="scene"
      >
        <el-input
          v-model="formData.scene"
          placeholder="输入内容"/>

      </el-form-item>
    </el-form>

    <AppFormSubmit
      slot="footer"
      :submitting="loading"
      @submit="submit"
      @cancel="cancel"
    />
  </el-dialog>
</template>

<style lang="postcss" scoped>
</style>
